import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  templates: [],
  pagination: {
    page: 0,
    size: 10,
    totalElements: 0,
    totalPages: 0,
  },
  templateParameter: {
    name: "",
    scope: "TEMPLATE",
    settings: {
      rowHeight: 25,
      columnWidth: 100,

      borderColor: "#000000",
      borderWidth: 0,
      borderStyle: "",
      applyBorderTo: {
        header: false,
        dataRows: false,
        entireTable: false,
      },

      headerFontSize: 14,
      headerFontStyle: "normal",
      headerFontWeight: 400,
      headerBackgroundColor: "#FFFFFF",
      headerForegroundColor: "#000000",
      headerUnderline: false,

      rowFontSize: 14,
      rowForegroundColor: "#000000",
      rowOddBackground: "#FFFFFF",
      rowEvenBackground: "#FFFFFF",
      rowFontStyle: "normal",
      rowFontWeight: 400,
      enableAlternateRows: false,

      showRowNumbers: false,
      freezeHeaderRow: false,
      showGridlines: true,
      enableFilter: false,
    },
  },
  isEdit: false,
  editId: "",
  originalScope: "",
};

const templateSlice = createSlice({
  name: "template",
  initialState,
  reducers: {
    setTemplateParameter(state, action) {
      state.templateParameter = action.payload;
    },

    setTemplates(state, action) {
      state.templates = action.payload;
    },

    setLoading(state, action) {
      state.loading = action.payload;
    },

    setEdit(state, action) {
      state.isEdit = true;
      state.editId = action.payload?.editid;
      state.templateParameter = action.payload?.parameters;
      state.originalScope = action.payload?.parameters?.scope || "";
    },

    resetEdit(state) {
      state.isEdit = false;
      state.editId = "";
      state.templateParameter = initialState.templateParameter;
      state.originalScope = "";
    },
    setPagination(state, action) {
      state.pagination = action.payload;
    },
  },
});

export const templateAction = templateSlice.actions;
export const templateReducer = templateSlice.reducer;
